import { render, staticRenderFns } from "./selectGame.vue?vue&type=template&id=b896c6ec&scoped=true"
import script from "./selectGame.vue?vue&type=script&lang=js"
export * from "./selectGame.vue?vue&type=script&lang=js"
import style0 from "./selectGame.vue?vue&type=style&index=0&id=b896c6ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896c6ec",
  null
  
)

export default component.exports